import { EPage } from '@/shared/enum/page.enum'
import type { NavigationGuard } from 'vue-router'

export const resultGuard: NavigationGuard = (to, _from, next) => {
  if (!to.params.folio || to.params.folio === '') {
    return next({ name: EPage.PACKAGES })
  }
  return next()
}
